const LEGACY_AUTH_DATABASE = "keyval-store";
const LEGACY_AUTH_STORE = "keyval";
const LEGACY_ACCESS_TOKEN_KEY = "lightning_node_jwt_token";
export function createLegacyAccessTokenProvider(reader = new IndexedDbKeyValueReader()) {
    return async () => {
        try {
            const value = await reader.read(LEGACY_AUTH_DATABASE, LEGACY_AUTH_STORE, LEGACY_ACCESS_TOKEN_KEY);
            return typeof value === "string" && value.length > 0 ? value : undefined;
        }
        catch {
            return undefined;
        }
    };
}
class IndexedDbKeyValueReader {
    async read(database, store, key) {
        if (!("indexedDB" in globalThis))
            return undefined;
        const connection = await openDatabase(globalThis.indexedDB, database);
        try {
            if (!connection.objectStoreNames.contains(store))
                return undefined;
            return await readValue(connection, store, key);
        }
        finally {
            connection.close();
        }
    }
}
function openDatabase(factory, name) {
    return new Promise((resolve, reject) => {
        const request = factory.open(name);
        request.addEventListener("success", () => resolve(request.result), { once: true });
        request.addEventListener("error", () => reject(request.error), { once: true });
    });
}
function readValue(database, store, key) {
    return new Promise((resolve, reject) => {
        const transaction = database.transaction(store, "readonly");
        const request = transaction.objectStore(store).get(key);
        request.addEventListener("success", () => resolve(request.result), { once: true });
        request.addEventListener("error", () => reject(request.error), { once: true });
    });
}
//# sourceMappingURL=legacy-session-token.js.map